import type { IconData } from '@stacksjs/iconify-core'

export const handDislike: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24.375 1.52v1.53h-3.05v1.52h3.05v15.24h-1.52v1.52h1.52v1.53h6.1V1.52z\"/><path fill=\"currentColor\" d=\"M19.805 21.33h3.05v1.53h-3.05Zm0-19.81h1.52v1.53h-1.52Zm-1.52 21.34h1.52v1.52h-1.52Zm-1.53 1.52h1.53v6.1h-1.53Zm-3.04 6.1h3.04V32h-3.04Zm0-10.67h1.52v1.52h-1.52Zm-1.53 9.14h1.53v1.53h-1.53Zm0-7.62h1.53v1.53h-1.53Zm-7.62-3.04h9.15v1.52h-9.15Zm6.1 4.57h1.52v6.09h-1.52ZM6.095 0h13.71v1.52H6.095Zm4.57 6.1V4.57h-6.1V3.05h-1.52V6.1zm-6.1-4.58h1.53v1.53h-1.53Zm-1.52 15.24h1.52v1.53h-1.52Zm6.09-1.52v-1.53h-6.09v-3.04h6.09V9.14h-6.09V6.1h-1.52v10.66h1.52v-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handDislike
